export default __webpack_public_path__ + "static/media/parokshaba.3d18b256.png";